import React, { ReactElement, ReactNode } from "react";
import {
  Box,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router";
import MoreVert from "@icons/myicons/dots.svg?react";
import AddIcon from "@icons/myicons/plus.svg?react";
import { ActionsMenu } from "./ActionsMenu";

export interface PrimaryActionWithMenuProps {
  primaryActionText: string;
  primaryActionUrl?: string;
  primaryActionOnClick?: () => void;
  primaryActionDisabled?: boolean;
  startIcon?: ReactElement;
  children: ReactNode;
}

export const PrimaryActionWithMenu = ({
  primaryActionText,
  primaryActionUrl,
  primaryActionOnClick,
  primaryActionDisabled = false,
  startIcon = <AddIcon width="18px" height="12px" />,
  children,
  ...rest
}: PrimaryActionWithMenuProps) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isMoreMd = useMediaQuery(theme.breakpoints.up("md"));

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePrimaryButtonClick = () => {
    if (primaryActionOnClick) {
      primaryActionOnClick();
      return;
    } else if (primaryActionUrl) {
      navigate(primaryActionUrl);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexShrink={0}
      gap={2}
    >
      {isMoreMd && (
        <Button
          variant="outlined"
          size="small"
          startIcon={startIcon}
          onClick={handlePrimaryButtonClick}
          disabled={primaryActionDisabled}
          data-testid="primary-action-button"
          sx={{ marginRight: theme.spacing(2) }}
          {...rest}
        >
          {primaryActionText}
        </Button>
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gap={2}
      >
        <IconButton
          className="rangeSelectorButton"
          data-testid="open-menu-button"
          aria-controls="simple-menu"
          aria-haspopup="true"
          color="tertiary"
          size="small"
          onClick={handleOpenMenu}
        >
          <MoreVert />
        </IconButton>
        <ActionsMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
          {children}
        </ActionsMenu>
      </Box>
    </Box>
  );
};
